
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IsString } from 'class-validator';

@Injectable({
	providedIn: 'root'
})
export class StakeholderService {
	url = environment.apiUrl;
	constructor(private http: HttpClient) {}

	getStakeholder(): Observable<any[]> {

        // const httpOptions = {
        //     headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        //     type: type
        // };
      
        // let params = new HttpParams();
        // params = params.append('type', type);

        // console.log("Http Options ", httpOptions);
         
		return this.http.get<any[]>(this.url + 'stakeholder' );
  }
  


	createStakeholder(data: any[]): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
         
		return this.http.post<any[]>(this.url + 'stakeholder/createStakeholder', data);
	}
	getSingleStakeholder(id: string): Observable<any> {

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
        //   let params = new HttpParams();
        //   params = params.append('type', type);
		return this.http.get(this.url + 'stakeholder/' + id,httpOptions);
	}

	updateStakeholder(data: any[], deletedData: any[]): Observable<any[]> {
 //console.log("Reaching Update function ", type);
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
        //   let params = new HttpParams();
        //   params = params.append('type', type);

        let newDataStruct = { data: data, deletedData: deletedData}

		return this.http.post<any[]>(this.url + 'stakeholder/update', newDataStruct);
	}

	deleteStakeholder(ids: any) {
    console.log("Reaching App Delete Service", ids );
    const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			body: ids
		};

		let params = new HttpParams();
    params = params.append('stakeholderRef', ids.join(', '));
    
   
		return this.http.delete(this.url + 'stakeholder', httpOptions);
	}
}
